import { useCallback, useState } from 'react'

export type TInputChangeHandler = (_: React.ChangeEvent<{}>, newInputValue: string) => void

type TUseAutocompleteInputStateReturn = [string, TInputChangeHandler]

/**
 * Manages typed input state
 */
export const useAutocompleteInputState = (
  defaultInputValue: string = ''
): TUseAutocompleteInputStateReturn => {
  const [inputValue, setInputValue] = useState<string>(defaultInputValue)

  const inputChangeHandler: TInputChangeHandler = useCallback((_, newInputValue) => {
    setInputValue(newInputValue)
  }, [])

  return [inputValue, inputChangeHandler]
}
